import getFetchWrapper from 'syf-api/api/getFetchWrapper';
import ENDPOINTS from '../../../const/endpoints';
const mutationFnFactory = (config, keyProps) => {
    const fetchWrapper = getFetchWrapper(config);
    return ({ newDueDay, sendLetter }) => {
        const requestPayload = {
            'cipher.accountId': keyProps.accountId,
            accountIdType: keyProps.accountIdType,
            newDueDay,
            sendLetter
        };
        return fetchWrapper(ENDPOINTS.changePaymentDueDate, {
            method: 'PUT',
            body: JSON.stringify(requestPayload)
        });
    };
};
export default mutationFnFactory;
